import { TCustomCell } from "components/Category/Category";
import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import ReactDOM from "react-dom";

type Props<T> = {
  customRowCells: { [k in keyof T]?: TCustomCell<T> | undefined };
  row: { [K in keyof T]: React.ReactNode };
  k: string;
  id: string;
  setCustomCellValue?: React.Dispatch<any>;
  customCellValue?: any;
  refs?: { selectRef?: any; containerRef?: any };
  parentSelectedId?: number;
};
export const SingleSelectCell = <T extends { [K: string]: React.ReactNode }>(
  props: Props<T>
) => {
  const {
    row,
    customRowCells,
    k,
    id,
    customCellValue,
    setCustomCellValue,
    refs,
    parentSelectedId,
  } = props;
  const selectOptions =
    (row[customRowCells[k]?.dataSource as keyof T] as any[]) ?? [];

  const selected = customCellValue?.find(
    (r: any) => r.id.toString() === id.toString()
  ) as any;

  const selectRef = useRef<any>(null);

  const handleMenuOpen = () => {
    if (!refs?.containerRef) return;
    setTimeout(() => {
      const selectRect = selectRef?.current?.select?.controlRef.getBoundingClientRect();
      const containerRect = refs?.containerRef.current.getBoundingClientRect();
      const menuRect = selectRef.current?.select?.menuListRef?.getBoundingClientRect();
      const bodyRect = document.body.getBoundingClientRect();
      const distanceToBottom = bodyRect?.bottom - menuRect?.bottom;
      const distanceToBottom2 = containerRect?.bottom - menuRect?.bottom;
      if (distanceToBottom2 <= 18) {
        refs.containerRef.current.scrollTop += Math.abs(distanceToBottom2) + 18;
      }
    }, 0);
  };

  const [openSelect, setOpenSelect] = useState<any>(null);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  useEffect(() => {
    if (parentSelectedId) return;
    if (!openSelect) return;
    const handleScroll = (event: any) => {
      if (
        openSelect &&
        refs?.containerRef?.current &&
        !refs?.containerRef?.current.contains(event?.target)
      ) {
        // openSelect?.blur();
        setOpenSelect(() => null); //setOpenSelect(null);
      }
    };
    document.addEventListener("scroll", handleScroll, true);
    return () => {
      document.removeEventListener("scroll", handleScroll, true);
    };
  }, [openSelect]);
  const handleSelectOpen = (ref: any) => {
    setOpenSelect(() => ref); //setOpenSelect(ref);
  };

  return (
    <>
      <div
        onClick={event => {
          event.stopPropagation();
        }}
        id={`${k}-${id}`}
        style={{ position: "relative" }}
      >
        <Select
          ref={ref => {
            refs?.selectRef && refs?.selectRef(ref);

            selectRef.current = ref;
          }}
          key={`${k}-${id}`}
          value={selectOptions?.find(
            ds => selected && ds.value === selected[k]
          )}
          options={selectOptions}
          onChange={(option, actionMeta) => {
            setCustomCellValue &&
              setCustomCellValue((v: any[]) =>
                v.map(e =>
                  e.id.toString() === id.toString()
                    ? { ...e, [k]: option.value }
                    : e
                )
              );
          }}
          menuIsOpen={menuOpen}
          onMenuOpen={() => {
            setMenuOpen(true); // NOTE: This is needed to make click on mobile phones work
          }}
          onMenuClose={() => {
            setMenuOpen(false); // NOTE: This is needed to make click on mobile phones work
          }}
          className="CustomSelect RoundedRect"
          classNamePrefix={"CustomSelect"}
          menuPosition="fixed" //better to hav it fixed otherwise the entire page (doc or pm) lifts up with gap underneath
          menuPlacement="auto"
          styles={{
            menu: (provided, state: any) => ({
              ...provided,
            }),
            menuPortal: base => {
              return {
                ...base,
                zIndex: parentSelectedId ? 850 : 29,
              };
            },
          }}
          menuPortalTarget={parentSelectedId ? document.body : document.body}
          menuShouldScrollIntoView
          closeMenuOnScroll={(event: any) => {
            return (
              !event?.target?.classList?.contains("CustomSelect__menu-list") &&
              event.target.nodeName !== "#document"
            );
          }}
        />
      </div>
    </>
  );
};
